import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { useGetHistoryDisabledState } from 'app/modules/wallforming/components/placement-history/hooks/useGetHistoryDisabledState';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Undo = () => {
    const { t } = useTranslation();
    const disabled = useGetHistoryDisabledState();
    
    const { canUndo, undo } = usePlacementStore(
        useShallow((state) => ({
            canUndo: state.canUndo,
            undo: state.undo
        }))
    );

    return (
        <Menu.Item
            disabled={disabled || !canUndo}
            leftSection={<Icon aria-hidden="true" icon="undo" />}
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralUndo} />}
            onClick={() => undo()}
        >
            {t('undo')}
        </Menu.Item>
    );
};
